import AreaParser from './main';
import MiniAreaParser from './mini';
export default {
    main: AreaParser,
    mini: MiniAreaParser,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/geoms/area/index.js
// module id = null
// module chunks = 